<template>
  <section class="hero-section">
    <div class="hero-slider">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="hero-slide"
        :class="{ active: currentSlide === index }"
        :style="{ backgroundImage: `url(${slide.image})` }"
      >
        <div class="hero-overlay"></div>
        <div class="container">
          <div class="hero-content">
            <h1 class="hero-title animated fadeInUp" :style="{ animationDelay: '200ms' }">
              {{ $i18n.t(slide.titleKey) }}
            </h1>
            <p class="hero-desc animated fadeInUp" :style="{ animationDelay: '400ms' }">
              {{ $i18n.t(slide.descKey) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 轮播指示器 -->
    <div class="hero-indicators animated fadeIn" :style="{ animationDelay: '600ms' }">
      <button
        v-for="(slide, index) in slides"
        :key="index"
        class="indicator"
        :class="{ active: currentSlide === index }"
        @click="goToSlide(index)"
        :aria-label="`切换到第${index + 1}张`"
      ></button>
    </div>

    <!-- 左右切换按钮 -->
    <button class="hero-btn hero-prev" aria-label="上一张" @click="prevSlide">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>
    <button class="hero-btn hero-next" aria-label="下一张" @click="nextSlide">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const currentSlide = ref(0)
let autoPlayTimer = null

const slides = [
  {
    titleKey: 'hero.title2',
    descKey: 'hero.desc2',
    image: new URL('@/assets/pic/ban.jpg', import.meta.url).href,
  },
  {
    titleKey: 'hero.title3',
    descKey: 'hero.desc3',
    image: new URL('@/assets/pic/2.jpg', import.meta.url).href,
  },
  {
    titleKey: 'hero.title1',
    descKey: 'hero.desc1',
    image: new URL('@/assets/pic/3.jpg', import.meta.url).href,
  },
]

const goToSlide = (index) => {
  currentSlide.value = index
  resetAutoPlay()
}

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1) % slides.length
  resetAutoPlay()
}

const prevSlide = () => {
  currentSlide.value = (currentSlide.value - 1 + slides.length) % slides.length
  resetAutoPlay()
}

const startAutoPlay = () => {
  autoPlayTimer = setInterval(() => {
    nextSlide()
  }, 5000)
}

const resetAutoPlay = () => {
  if (autoPlayTimer) {
    clearInterval(autoPlayTimer)
  }
  startAutoPlay()
}

onMounted(() => {
  startAutoPlay()
})

onUnmounted(() => {
  if (autoPlayTimer) {
    clearInterval(autoPlayTimer)
  }
})
</script>

<style scoped>
.hero-section {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 37.5rem;
  /* margin-top: 65px; */
  overflow: hidden;
}

.hero-slider {
  position: relative;
  width: 100%;
  height: 100%;
}

.hero-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.hero-slide.active {
  opacity: 1;
  z-index: 1;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(10, 22, 40, 0.92) 0%,
    rgba(10, 22, 40, 0.75) 50%,
    rgba(10, 22, 40, 0.85) 100%
  );
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 50rem;
  padding-top: 35vh;
}

.hero-title {
  font-size: clamp(1.75rem, 4vw, 3.25rem);
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
  margin-bottom: 1.25rem;
  text-shadow: 0 0.13rem 1.25rem rgba(0, 0, 0, 0.3);
}

.hero-desc {
  font-size: clamp(1rem, 1.8vw, 1.25rem);
  color: #d1d5db;
  line-height: 1.8;
  max-width: 40.63rem;
  margin-bottom: 1.88rem;
}

/* 轮播指示器 */
.hero-indicators {
  position: absolute;
  bottom: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.75rem;
  z-index: 10;
}

.indicator {
  width: 2.5rem;
  height: 0.25rem;
  border-radius: 0.13rem;
  background-color: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.indicator:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.indicator.active {
  background-color: #4779B5;
  width: 3.75rem;
}

/* 切换按钮 */
.hero-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 3.13rem;
  height: 3.13rem;
  background-color: rgba(71, 121, 181, 0.2);
  border: 0.06rem solid rgba(71, 121, 181, 0.4);
  border-radius: 50%;
  color: #4779B5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
}

.hero-btn:hover {
  background-color: rgba(71, 121, 181, 0.4);
  border-color: #4779B5;
  transform: translateY(-50%) scale(1.05);
}

.hero-prev {
  left: 1.88rem;
}

.hero-next {
  right: 1.88rem;
}

.container {
  max-width: 87.5rem;
  margin: 0 auto;
  padding: 0 1.5rem;
}

@media (max-width: 64rem) {
  .hero-section {
    height: 100vh;
    min-height: 31.25rem;
    /* margin-top: 3.44rem; */
  }

  .hero-btn {
    width: 2.63rem;
    height: 2.63rem;
  }

  .hero-prev {
    left: 1.2rem;
  }

  .hero-next {
    right: 1.2rem;
  }
}

@media (max-width: 48rem) {
  .hero-section {
    height: 100vh;
    min-height: 28.13rem;
    /* margin-top: 3.13rem; */
  }

  .hero-content {
    padding-top: 10vh;
  }

  .container {
    padding: 0 1.25rem;
  }

  .hero-title {
    font-size: 1.5rem;
  }

  .hero-desc {
    font-size: 0.88rem;
  }

  .hero-btn {
    display: none;
  }

  .hero-indicators {
    bottom: 1.56rem;
  }
}
</style>
